import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { TARGET_GROUPS, IMAGES } from "../data/content";

export const Zielgruppen = () => (
  <section className="bg-white py-24 sm:py-32" data-testid="zielgruppen-section">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-8">
          <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">Für wen wir arbeiten</p>
          <h2 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-navy-900 leading-[1.05]">
            Vom Haushalt bis zur <span className="font-serif italic text-blue-700">Industrie.</span>
          </h2>
        </div>
        <p className="lg:col-span-4 text-slate-500 leading-relaxed">
          Jede Branche hat eigene Verbrauchsprofile. Wir analysieren individuell – SLP wie RLM.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-6">
        {TARGET_GROUPS.map((g, i) => {
          const layout = [
            "lg:col-span-8 min-h-[340px]",
            "lg:col-span-4 min-h-[340px]",
            "lg:col-span-4 min-h-[340px]",
            "lg:col-span-4 min-h-[340px]",
            "lg:col-span-4 min-h-[340px]",
          ];
          return (
            <Reveal key={g.key} delay={i * 0.08} className={layout[i]}>
              <Link to={g.to} className="group block h-full relative rounded-3xl overflow-hidden border border-slate-200" data-testid={`zielgruppe-${g.key}`}>
                <motion.img
                  src={IMAGES[g.img]}
                  alt={g.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-1000 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/50 to-navy-950/10" />
                <div className="relative z-10 h-full flex flex-col justify-end p-8">
                  <div className="flex items-center justify-between">
                    <h3 className="text-2xl font-heading text-white">{g.title}</h3>
                    <span className="h-10 w-10 grid place-items-center rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white group-hover:bg-blue-700 transition-colors duration-300">
                      <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                  <p className="text-sm text-slate-300 mt-3 max-w-md opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                    {g.text}
                  </p>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
